<template>
  <div id="app">
    <div class="navigation-bar" v-if="!$route.meta.hideNavigation">
      <Header />
      <SideBar />
    </div>
    <Login v-else />
  </div>
</template>

<script>
import Header from '@/layouts/Header.vue'
import SideBar from '@/layouts/SideBar.vue'
import Login from '@/view/Login.vue'

import auth from '@/service/auth.js'

export default {
  name: 'App',
  data () {
    return {

    }
  },
  components: {
    SideBar,
    Login,
    Header
  },
  async mounted() {
    const res = await auth.checkAuth(this.$route.fullPath)
    console.log('response false', res)
    if (res == false && this.$route.fullPath != '/login') {
      localStorage.clear()
      this.$router.push('/login')
    }
  }
}
</script>
